<template>
	<mask-div :auto="true" v-show="fullImgActive" @mask-click="closeMask">
    <img class="full_img_display" :src="src" @click="closeMask">
  </mask-div>
</template>

<script>
  import MaskDiv from 'components/mask/Maskdiv.vue'
  export default {
    props: {
      src: {
        type: String
      },
      fullImgActive: {
        type: Boolean
      },
      parentFun: {
        type: Function
      }
    },
    data () { return {} },
    methods: {
      // 监听子组件是否有被点击
      // 点击遮罩组件触发父组件的mask-click事件
      closeMask (event) {
        this.fullImgActive = false
        // 给组件添加一个事件监听
        this.$emit('fullImageClick', event)
        // this.parentFun()
      }
    },
    components: {
      MaskDiv
    }
  }
</script>

<style scoped lang="scss">
  .full_img_display {
    display: block;
    position: relative;
    height: 90%;
    margin: 40px auto;
  }
</style>


// WEBPACK FOOTER //
// FullImageDisplay.vue?26e9d8d0